/**
 * Vue Router
 * OP-2026-0129: Frontend Admin SaaS
 */

import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { SHELL } from '@/shell'
import { buildRoutes } from './routes'

// OP-20260810-004 (B2): a tabela de rotas depende do shell do build.
// 'app' -> App ERP (erp.elohimtech.com.br) | 'admin' -> Gestao SaaS (default)
const routes = buildRoutes(SHELL)

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  // Scroll to top on navigation
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

// Navigation guard
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  // Atualizar título da página
  document.title = to.meta.title ? `${to.meta.title} | DPS-ERP` : 'DPS-ERP'

  // Aguardar loading inicial
  if (authStore.loading) {
    // Esperar restauração da sessão
    await new Promise((resolve) => {
      const unwatch = authStore.$subscribe((mutation, state) => {
        if (!state.loading) {
          unwatch()
          resolve()
        }
      })
      // Timeout de segurança
      setTimeout(() => {
        unwatch()
        resolve()
      }, 3000)
    })
  }

  const requiresAuth = to.meta.requiresAuth !== false

  if (requiresAuth && !authStore.isAuthenticated) {
    // Salvar destino para redirect após login
    const redirectPath = to.fullPath !== '/' ? to.fullPath : undefined
    next({
      name: 'Login',
      query: redirectPath ? { redirect: redirectPath } : undefined
    })
  } else if (to.name === 'Login' && authStore.isAuthenticated) {
    // Já autenticado, redirecionar para a home do shell.
    // OP-20260810-004: destino por PATH, nao por nome. O shell 'app' nao tem
    // rota 'Dashboard' e resolver nome inexistente quebraria o login nele.
    // Em 'admin' o destino continua o mesmo: '/' = Dashboard.
    const redirect = to.query.redirect
    next(redirect || { path: '/' })
  } else {
    next()
  }
})

export default router
